import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=7978ba69"
import script from "./Providers.vue?vue&type=script&lang=js"
export * from "./Providers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports